export default {
  web: {
    status: {
      notFoundTitle: "Página no encontrada",
      notFoundDescription: "La página que buscas no existe o puede haber sido movida.",
      supportTitle: "Soporte",
      supportDescription: "Para recibir ayuda con tu cuenta o consultar sobre nuestros servicios, contáctanos por correo electrónico en support@linemate.io",
      goHome: "Ir al inicio",
      exploreTrends: "Explorar tendencias",
      openTrends: "Abrir tendencias",
      contactSupport: "Contactar soporte",
    },
    download: {
      title: "Descargar Linemate",
      subtitle: "Disponible para iOS, Android y web.",
      ios: "Descargar para iOS",
      android: "Descargar para Android",
    },
    manageSubscription: {
      title: "Administra tu suscripción",
      web: "Administrar en web",
      ios: "Administrar en iOS",
      android: "Administrar en Android",
    },
    auth: {
      loginTitle: "Inicia sesión en Linemate",
      signupTitle: "Regístrate en Linemate",
      noAccount: "¿No tienes una cuenta?",
      alreadyHaveAccount: "¿Ya tienes una cuenta?",
      signUp: "Regístrate",
      setupError: "Algo salió mal al configurar tu cuenta. Es posible que puedas completar el proceso desde la página de perfil.",
      usernameTooShort: "El nombre de usuario es demasiado corto (mín. 6 caracteres).",
      usernameAlphaNumeric: "El nombre de usuario solo puede contener letras y números.",
      termsPrefix: "Al continuar, aceptas los",
      termsOfService: "Términos de servicio",
      privacyPolicy: "Política de privacidad.",
      oddsFormatTitle: "Preferencias de formato de cuotas",
      oddsFormatDescription: "Antes de continuar a Linemate, configura tu preferencia para mostrar las cuotas en formato americano o decimal.",
      oddsFormat: "Formato de cuotas",
      passwordReset: {
        forgotTitle: "Olvidé mi contraseña",
        resetTitle: "Restablecer contraseña",
        instructions: "Ingresa el correo electrónico asociado con tu cuenta y te enviaremos un enlace para restablecer tu contraseña.",
        sentInstructions: "Pronto recibirás un correo para restablecer tu contraseña. Sigue el enlace del correo para cambiarla.",
        sendInstructions: "Enviar instrucciones",
        resendInstructions: "Reenviar instrucciones",
        returnToLogin: "Volver a iniciar sesión",
        signupPrompt: "¿No tienes una cuenta? Regístrate",
        sendError: "Algo salió mal al enviar las instrucciones para restablecer la contraseña. Inténtalo de nuevo más tarde.",
      },
      changePassword: {
        title: "Cambia tu contraseña",
        subtitle: "Ingresa tu nueva contraseña.",
        newPassword: "Nueva contraseña",
        confirmNewPassword: "Confirmar nueva contraseña",
        passwordChanged: "Contraseña cambiada",
        invalidLink: "No pudimos restablecer tu contraseña. El enlace que estás usando no es válido o expiró.",
        genericError: "No pudimos completar tu solicitud. Inténtalo de nuevo más tarde o envía el siguiente código a nuestro equipo para que lo revisemos: {{code}}",
      },
    },
    inputSelection: {
      clear: "Borrar",
    },
  },
};
